const SkillBar = ({ name, level, index, categoryName }) => {
  const label =
    level >= 90 ? "Expert" : level >= 80 ? "Advanced" : level >= 70 ? "Strong" : "Core";

  // Do not render numeric/graded labels for interpersonal categories
  const hideNumeric = categoryName === "Leadership" || categoryName === "Collaboration";

  if (hideNumeric) {
    return (
      <div className="skills__item">
        <div className="skills__item-header">
          <span className="skills__name">{name}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="skills__item">
      <div className="skills__item-header">
        <span className="skills__name">{name}</span>
        <span className="skills__level">{label}</span>
      </div>
      <div className="skills__bar">
        <div
          className="skills__bar-fill"
          style={{
            "--width": `${level}%`,
            "--index": index,
          }}
        />
      </div>
    </div>
  );
};

export default SkillBar;
